<template>
    <div>
        <Spinner v-if="loading" text="Adding deposit" />
        <b-input-group v-else prepend="Deposit" size="sm" class="mb-1">
            <b-form-input
                placeholder="Balance"
                type="number"
                v-model="addBalance"
            />
            <b-input-group-prepend is-text>
                {{ addBalance | formatCurrency }}
            </b-input-group-prepend>
            <b-form-input
                placeholder="Credit"
                type="number"
                v-model="addCredit"
            />
            <b-input-group-prepend is-text>
                {{ addCredit | formatCurrency }}
            </b-input-group-prepend>
            <b-input-group-append>
                <b-button variant="outline-success" @click="add">Add</b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>

<script>
    import axios from '@/services/axios'

    import Spinner from '@/components/general/spinner'

    export default {
        props: ['id'],
        data() {
            return {
                addBalance: '',
                addCredit: '',
                loading: false
            }
        },
        methods: {
            add() {
                if (this.addBalance === '' && this.addCredit === '') {
                    console.log('fhcdwsj')
                    return this.$bvToast.toast('Data is invalid.', {
                        title: 'Error',
                        variant: 'warning'
                    })
                }
                this.loading = true
                axios
                    .post('admin/users/deposit', {
                        id: this.id,
                        addBalance: this.addBalance,
                        addCredit: this.addCredit
                    })
                    .then(res => {
                        this.$bvToast.toast(res.data, {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
                    .catch(error => {
                        this.$bvToast.toast(error.response.data, {
                            title: 'Error',
                            variant: 'warning'
                        })
                    })
                    .finally(() => (this.loading = false))
            }
        },
        components: {
            Spinner
        }
    }
</script>